module.exports = __webpack_public_path__ + "80c8a15c4c2439969234417737065c9a.glb";